const initialState = (() => {
  try {
    const data = localStorage.getItem("app_state");
    return data ? JSON.parse(data) : {};
  } catch (e) {
    return {};
  }
})();

export default function localReducer(state = initialState, action : any) {
  switch (action.type) {
    case "SET_ITEM":
      const newState = {
        ...state,
        [action.key]: action.value,
      };
      localStorage.setItem("app_state", JSON.stringify(newState));
      return newState;

    default:
      return state;
  }
}
